(() => {
  if (!customElements.get('mox-restored-typing')) {
    class MoxRestoredTyping extends HTMLElement {
      connectedCallback() {
        clearTimeout(this.timer);
        this.target = this.querySelector('[data-mox-typed]');
        this.text = this.dataset.text || '';
        this.characters = Array.from(this.text);
        this.highlight = this.dataset.highlight || 'TCG';
        this.highlightStart = this.text.indexOf(this.highlight);
        this.index = 0;
        this.deleting = false;
        if (!this.target || !this.text) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.motion.matches) { this.renderText(this.text); return; }
        this.renderText(this.text);
        this.visible = false;
        this.tick = () => {
          this.timer = null;
          if (!this.isConnected || !this.visible || document.hidden) return;
          if (this.motion.matches) { this.renderText(this.text); return; }
          this.index += this.deleting ? -1 : 1;
          this.renderText(this.characters.slice(0, this.index).join(''));
          let delay = this.deleting ? 50 : 100;
          if (this.index >= this.characters.length) { this.deleting = true; delay = 1500; }
          else if (this.index <= 0) { this.deleting = false; delay = 350; }
          this.timer = setTimeout(this.tick, delay);
        };
        this.resume = () => {
          clearTimeout(this.timer);
          this.timer = null;
          if (this.motion.matches) { this.renderText(this.text); return; }
          if (this.visible && !document.hidden) this.timer = setTimeout(this.tick, 100);
        };
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.visible = entries.some(entry => entry.isIntersecting);
          this.resume();
        });
        this.visibilityObserver.observe(this);
        document.addEventListener('visibilitychange', this.resume);
        this.motion.addEventListener('change', this.resume);
      }
      renderText(value) {
        const start = this.highlightStart;
        if (start < 0 || value.length <= start) {
          this.target.textContent = value;
          return;
        }
        const highlight = document.createElement('span');
        highlight.className = 'mox-typing-tcg';
        highlight.textContent = value.slice(start, start + this.highlight.length);
        this.target.replaceChildren(
          document.createTextNode(value.slice(0, start)),
          highlight,
          document.createTextNode(value.slice(start + this.highlight.length))
        );
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.visibilityObserver?.disconnect();
        document.removeEventListener('visibilitychange', this.resume);
        this.motion?.removeEventListener('change', this.resume);
      }
    }
    customElements.define('mox-restored-typing', MoxRestoredTyping);
  }
  let queued = false;
  const unavailableSelector = 'product-card[data-mox-available="false"][data-mox-used="true"]';
  const prune = () => {
    queued = false;
    document.querySelectorAll('#MainContent product-card[data-mox-available="false"][data-mox-used="true"]').forEach(card => {
      const item = card.closest('.resource-list__item,.product-grid__item,.product-list-slider__slide,.resource-list__slide');
      if (item && item.closest('#MainContent')) item.remove(); else card.remove();
    });
  };
  const start = () => {
    prune();
    const main = document.querySelector('#MainContent');
    if (!main) return;
    new MutationObserver(records => {
      if (queued || !records.some(r => Array.from(r.addedNodes).some(n => n instanceof Element && (n.matches(unavailableSelector) || n.querySelector(unavailableSelector))))) return;
      queued = true;
      requestAnimationFrame(prune);
    }).observe(main, {childList: true, subtree: true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();

